import log from 'loglevel'
import { isNil } from 'lodash/fp'
import { fetchUtils } from 'react-admin'

import {
  CognitoUserPool,
  type CognitoUserSession
} from 'amazon-cognito-identity-js'

import cognito from '../UserAuth/cognito.json'
import { type AnnounceItem } from '../../../../cdk/bapp/lib/lambda-api/src/types'

const env = process.env['ENV'] as string
const userCognito: Record<string, { userPoolId: string; clientId: string }> =
  cognito[env as keyof typeof cognito]

export const url = !isNil(process.env['API_LOCAL'])
  ? 'http://localhost:14001/v1'
  : {
      prd: 'https://api.bapp.terashite.jp/v1',
      stg: 'https://api-stg.bapp.terashite.jp/v1',
      int: 'https://api-int.bapp.dev.terashite.jp/v1',
      dev: 'https://api-dev.bapp.terashite.jp/v1',
      exp: 'https://api-exp.bapp.dev.terashite.jp/v1'
    }[env]
const announceUserUrl = `${url as string}/announce/bapp/all`

log.setLevel(log.levels.DEBUG)

export const getCustomHeaders = (
  options: fetchUtils.Options = {},
  partner?: string | undefined
): Headers | undefined => {
  if (isNil(partner)) return undefined
  const userCognitoByPartner = userCognito[partner]
  if (isNil(userCognitoByPartner)) return undefined
  const { userPoolId: UserPoolId, clientId: ClientId } = userCognitoByPartner
  const userPool = new CognitoUserPool({
    UserPoolId,
    ClientId
  })
  const cognitoUser = userPool.getCurrentUser()
  if (isNil(cognitoUser)) return undefined
  let session: any
  cognitoUser.getSession(
    (error: Error, newSession: CognitoUserSession | null) => {
      if (!isNil(error)) {
        log.error('[DataProvider.fetchJson]', { error })
        return
      }
      session = newSession
    }
  )
  if (isNil(session)) return undefined
  const customHeaders = (
    !isNil(options.headers)
      ? options.headers
      : new Headers({
          Accept: 'application/json'
        })
  ) as Headers
  customHeaders.set('Authorization', session.getIdToken().getJwtToken())
  if (!isNil(partner)) {
    customHeaders.set('X-Partner', partner)
  }
  return customHeaders
}
export const fetchJson =
  (partner: string | undefined) =>
  (url: string, options: fetchUtils.Options = {}): any => {
    const customHeaders = getCustomHeaders(options, partner)
    if (isNil(customHeaders)) return undefined
    options.headers = customHeaders
    return fetchUtils.fetchJson(url, options)
  }
export const getAnnouncesUser = async (
  partner: string
): Promise<AnnounceItem[] | undefined> => {
  const { status, json } = await fetchJson(partner)(announceUserUrl, {
    method: 'GET'
  })
  return status !== 200 ? undefined : json
}
